var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneTakeIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5745 24.109H0.886525C0.39672 24.109 0 24.4943 0 24.97V26.6921C0 27.1678 0.39672 27.5531 0.886525 27.5531H34.5745C35.0643 27.5531 35.461 27.1678 35.461 26.6921V24.97C35.461 24.4943 35.0643 24.109 34.5745 24.109ZM2.48282 11.0676L7.39971 15.3727C7.80315 15.7265 8.28656 15.9833 8.81095 16.1224L24.7462 20.3387C26.2134 20.7267 27.7693 20.808 29.2343 20.4119C30.8782 19.9669 31.6412 19.2705 31.8523 18.4902C32.0645 17.7099 31.7564 16.7299 30.5574 15.5326C29.4891 14.466 28.1001 13.768 26.6329 13.38L21.2301 11.9507L15.6693 1.62632C15.5857 1.31366 15.3397 1.06934 15.0233 0.985388L11.4168 0.0312545C10.8317 -0.123732 10.2588 0.317548 10.2693 0.915967L12.9244 9.75287L7.26175 8.25467L5.73305 4.60173C5.62611 4.33858 5.40004 4.14054 5.12245 4.06735L2.9211 3.48454C2.34818 3.33278 1.78358 3.75361 1.77305 4.33911L1.78579 9.81637C1.79632 10.2959 2.1199 10.7495 2.48282 11.0676Z",
    fill: "#86B817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneTakeIn);
export default __webpack_public_path__ + "static/media/plane_take_in.ba0d55e064c2f799434bf4299d392a6b.svg";
export { ForwardRef as ReactComponent };